module.exports = __webpack_public_path__ + "img/video.8b567e8c.svg";